import { signedFetch } from './client';

export async function listIngestionSources(storeName: string) {
  return signedFetch('GET', `/stores/${storeName}/ingestion-sources`);
}
